module.exports = __webpack_public_path__ + "static/jay-hasselbeck-coastal-advisory-group-d48d62f1a0ccac9d01c06327ee9a7e6b.png";